import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();

  const validPaths = [
    '/',
    '/website-design',
    '/performance-marketing',
    '/white-label-seo',
    '/white-label-digital-marketing',
    '/seo-service',
    '/affordable-seo-services-in-india',
    '/affordable-seo-services-south-africa',
    '/web-development-services',
    '/web-development-company-india',
    '/about-us',
    '/contact',
    '/admin',
    '/admin/seo-leads',
    '/ai-search-visibility',
    '/gmb-optimization',
    '/ai-automation-tools',
    '/book-a-slot',
    '/privacy-policy',
    '/digital-market',
    '/2'
  ];

  const normalizedPath = location.pathname.endsWith('/') && location.pathname.length > 1
    ? location.pathname.slice(0, -1)
    : location.pathname;

  const isBlog = normalizedPath === '/blog' || normalizedPath.startsWith('/blog/');
  const isTeam = normalizedPath.startsWith('/team/');
  const is404 = !validPaths.includes(normalizedPath) && !isBlog && !isTeam;
  const hideFooter = location.pathname === '/privacy-policy' || is404;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-20">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
